(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

$(document).ready(function () {
	$('#calendar').fullCalendar({
		header: {
			left: 'prev,next today',
			center: 'title',
			right: 'month,basicWeek,basicDay'
		},
		defaultDate: default_date_val,
		editable: false,
		events: events_data,
		eventClick: function eventClick(calEvent, jsEvent, view) {

			var start_is_am = true,
			    end_is_am = true,
			    sh = calEvent.start.hour(),
			    eh = calEvent.end.hour(),
			    cat_cut_off = 4;

			console.log(calEvent);
			//if(calEvent.ec_uid == 7) cat_cut_off = 7;

			if (sh > 12) {
				start_is_am = false;sh = calEvent.start.hour() - 12;
			}
			if (eh > 12) {
				end_is_am = false;eh = calEvent.end.hour() - 12;
			}

			var start_time = sh + ':' + addZero(calEvent.start.minute()),
			    end_time = eh + ':' + addZero(calEvent.end.minute());

			var start_time_frame = start_is_am ? 'am' : 'pm',
			    end_time_frame = end_is_am ? 'am' : 'pm';

			popUpMsg('<input type="hidden" id="cur_ec_uid" name="cur_ec_uid" value="' + calEvent.ec_uid + '" />Category: ' + com_name[calEvent.ec_uid] + '<br /><br />Event: <span class="current_title_text">' + calEvent.title + '</span><br /><br />Start Time: <span class="current_start_time">' + (1 + calEvent.start.month()) + '/' + calEvent.start._a[2] + '/' + calEvent.start.year() + ' ' + (start_time != '0:00' ? start_time + '' + start_time_frame : '') + (calEvent.end ? '</span><br /><br />End Time: <span class="current_end_time">' + (1 + calEvent.end.month()) + '/' + calEvent.end._a[2] + '/' + calEvent.end.year() + ' ' + (end_time != '0:00' ? end_time + '' + end_time_frame : '') : '') + '</span><br /><br /><p style="text-align: center; margin-top: 5px;"><button data rel="' + calEvent.uid + '" id="edit_event">EDIT</button> <button rel="' + calEvent.uid + '" id="delete_event">DELETE</button></p>');
			$(this).css('border-color', 'teal');

			$(".pop_up").draggable().resizable();
		}
	});

	$('.fc-header-left').append('&nbsp;&nbsp;<span id="new_event" class="fc-button fc-button-month fc-state-default fc-corner-left fc-corner-right ">NEW EVENT</span>');
});

$(document).on('click', '#delete_event', function () {
	$.post('/facility/members/delete-event', { uid: $(this).attr('rel') }, function (data) {
		window.location = '/facility/members/calendar';
		if (data.status == 'error') {
			popUpMsg('Failed to delete event.');
		}
	}, 'json');

	if (!logged_in) {
		removePopUpAndOverlay();
		popUpMsg('Please <a href="/register">register</a> to modify events.');
		return;
	}
});

$(document).on('click', '#create', function () {

	var t1 = new Date($('#start').val()).getTime();
	var t2 = new Date($('#end').val()).getTime();

	if (t1 > t2) {
		removePopUpAndOverlay();
		popUpMsg('Please enter a start date that is before the selected end date.');
		return;
	}

	$.post('/facility/members/save-event', $('#new_event_form').serialize(), function (data) {
		window.location = '/facility/members/calendar';
		if (data.status == 'error') {
			popUpMsg('Failed to save event.');
		}
	}, 'json');

	removePopUpAndOverlay();

	if (!logged_in) popUpMsg('Please <a href="/register">register</a> to add events.');
});

$(document).on('click', '#new_event', print_edit_create_event_form);
$(document).on('click', '#edit_event', function () {

	var cur_title = $('.current_title_text').text();
	var current_start = $('.current_start_time').text();
	var current_end = $('.current_end_time').text();
	var current_ec_uid = $('#cur_ec_uid').val();

	removePopUpAndOverlay();
	print_edit_create_event_form($(this).attr('rel'), cur_title, current_start, current_end, current_ec_uid, 1);
});

function print_edit_create_event_form(i) {

	var html = '<form id="new_event_form">';
	html += '<p><strong>Category</strong><div class="whiteArrow" style="width:100%;"><select id="ec_uid" name="ec_uid" class="custom-select" id="payment_type" style="color: #727272 !important; font-size: 18px; margin-top: 3px;"><option value="2"' + (arguments[4] == 2 ? ' selected="selected"' : '') + '>Resident Choice</option><option value="3"' + (arguments[4] == 3 ? ' selected="selected"' : '') + '>Quality of Life</option><option value="4"' + (arguments[4] == 4 ? ' selected="selected"' : '') + '>Clinical Care</option><option value="6"' + (arguments[4] == 6 ? ' selected="selected"' : '') + '>Management Practices</option><option value="5"' + (arguments[4] == 5 ? ' selected="selected"' : '') + '>Facility Standards</option><option value="7"' + (arguments[4] == 7 ? ' selected="selected"' : '') + '>Surveys</option><option value="8"' + (arguments[4] == 8 ? ' selected="selected"' : '') + '>Audits</option><option value="9"' + (arguments[4] == 9 ? ' selected="selected"' : '') + '>Other</option></select></div></p>';
	html += '<p><strong>Start</strong><input id="start" name="start" value="' + (arguments[2] != undefined ? arguments[2] : '') + '" readonly /></p>';
	html += '<p><strong>End</strong><input id="end" name="end" value="' + (arguments[3] != undefined ? arguments[3] : '') + '" readonly /></p>';
	html += '<p><strong>Description</strong><textarea id="desc" name="desc" rows="5">' + (arguments[1] != undefined ? arguments[1] : '') + '</textarea></p>';
	html += '<input type="hidden" value="' + (!isNaN(i) ? i : '') + '" name="uid" id="uid" />';
	html += '</form>';
	html += '<p style="text-align: center; margin-top: 5px;"><button id="create">' + (arguments[5] ? 'SAVE' : 'CREATE') + ' EVENT</button> <button id="close" onclick="removePopUpAndOverlay();">CANCEL</button></p>';

	popUpBlock(html);

	$("#start, #end").datetimepicker({
		timeFormat: "hh:mm tt",
		changeMonth: true,
		dateFormat: 'mm/dd/yy'
	});
}

function popUpBlock(html) {
	$('body').prepend('<div class="pop_up" style="text-align:left;"><p style="text-align:left;font-size:125%;">' + html + '</div><div class="overlay"></div>');
	$(".pop_up").draggable().resizable({ minHeight: '333', minWidth: '245' });
	$('#msgClose').click(function () {
		removePopUpAndOverlay();
	});
}

function popUpMsg(msg) {
	$('body').prepend('<div class="pop_up"><p style="text-align:left;font-size:125%;"><i id="msgClose" class="icon-cancel-circled" data-icon="i" style="cursor: pointer; position: absolute !important; top: 5px; right: 5px; font-size: 24px;"></i>' + msg + '</p></div><div class="overlay"></div>');
	$('#msgClose').click(function () {
		removePopUpAndOverlay();
	});
}

function removePopUpAndOverlay() {
	$('.pop_up, .overlay').remove();
}

function addZero(num) {
	String(num).length < 2 && !isNaN(num) ? num = String("0" + num) : num = String(num);
	return num;
}

},{}]},{},[1]);
